import { render, staticRenderFns } from "./FacturacionClButton.vue?vue&type=template&id=b0e3d560&"
import script from "./FacturacionClButton.vue?vue&type=script&lang=js&"
export * from "./FacturacionClButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports